"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: client-proxy/client-proxy-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fclient-proxy%2Fclient-proxy-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientProxyServiceClient = exports.GetUserDataResponse = exports.GetUserDataRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const card_provider_key_1 = require("../acquiring/card-provider-key");
const profile_1 = require("../auth/profile");
const external_account_1 = require("../common/external-account");
const referral_state_1 = require("../referral/referral-state");
const user_1 = require("../user/user");
const account_data_1 = require("./account-data");
const family_1 = require("./family");
const plaid_1 = require("./plaid");
const protobufPackage = 'com.step.clientproxy.proto';
function createBaseGetUserDataRequest() {
    return {};
}
exports.GetUserDataRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetUserDataRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetUserDataRequest();
        return message;
    },
};
function createBaseGetUserDataResponse() {
    return {
        user: user_1.User.fromPartial({}),
        profile: profile_1.Profile.fromPartial({}),
        family: family_1.Family.fromPartial({}),
        referralState: referral_state_1.ReferralState.fromPartial({}),
        accounts: [],
        externalAccounts: [],
        plaid: plaid_1.Plaid.fromPartial({}),
        providerKeys: [],
    };
}
exports.GetUserDataResponse = {
    fromJSON(object) {
        const message = {
            user: isSet(object.user) ? user_1.User.fromJSON(object.user) : user_1.User.fromPartial({}),
            profile: isSet(object.profile) ? profile_1.Profile.fromJSON(object.profile) : profile_1.Profile.fromPartial({}),
            family: isSet(object.family) ? family_1.Family.fromJSON(object.family) : family_1.Family.fromPartial({}),
            referralState: isSet(object.referralState)
                ? referral_state_1.ReferralState.fromJSON(object.referralState)
                : referral_state_1.ReferralState.fromPartial({}),
            accounts: globalThis.Array.isArray(object?.accounts)
                ? object.accounts.map((e) => account_data_1.AccountData.fromJSON(e))
                : [],
            externalAccounts: globalThis.Array.isArray(object?.externalAccounts)
                ? object.externalAccounts.map((e) => external_account_1.ExternalAccount.fromJSON(e))
                : [],
            plaid: isSet(object.plaid) ? plaid_1.Plaid.fromJSON(object.plaid) : plaid_1.Plaid.fromPartial({}),
            providerKeys: globalThis.Array.isArray(object?.providerKeys)
                ? object.providerKeys.map((e) => card_provider_key_1.ExternalCardProviderKey.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = user_1.User.toJSON(message.user);
        }
        if (message.profile !== undefined) {
            obj.profile = profile_1.Profile.toJSON(message.profile);
        }
        if (message.family !== undefined) {
            obj.family = family_1.Family.toJSON(message.family);
        }
        if (message.referralState !== undefined) {
            obj.referralState = referral_state_1.ReferralState.toJSON(message.referralState);
        }
        if (message.accounts?.length) {
            obj.accounts = message.accounts.map((e) => account_data_1.AccountData.toJSON(e));
        }
        if (message.externalAccounts?.length) {
            obj.externalAccounts = message.externalAccounts.map((e) => external_account_1.ExternalAccount.toJSON(e));
        }
        if (message.plaid !== undefined) {
            obj.plaid = plaid_1.Plaid.toJSON(message.plaid);
        }
        if (message.providerKeys?.length) {
            obj.providerKeys = message.providerKeys.map((e) => card_provider_key_1.ExternalCardProviderKey.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetUserDataResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserDataResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? user_1.User.fromPartial(object.user)
            : user_1.User.fromPartial({});
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? profile_1.Profile.fromPartial(object.profile)
            : profile_1.Profile.fromPartial({});
        message.family = (object.family !== undefined && object.family !== null)
            ? family_1.Family.fromPartial(object.family)
            : family_1.Family.fromPartial({});
        message.referralState = (object.referralState !== undefined && object.referralState !== null)
            ? referral_state_1.ReferralState.fromPartial(object.referralState)
            : referral_state_1.ReferralState.fromPartial({});
        message.accounts = object.accounts?.map((e) => account_data_1.AccountData.fromPartial(e)) || [];
        message.externalAccounts =
            object.externalAccounts?.map((e) => external_account_1.ExternalAccount.fromPartial(e)) || [];
        message.plaid = (object.plaid !== undefined && object.plaid !== null)
            ? plaid_1.Plaid.fromPartial(object.plaid)
            : plaid_1.Plaid.fromPartial({});
        message.providerKeys =
            object.providerKeys?.map((e) => card_provider_key_1.ExternalCardProviderKey.fromPartial(e)) || [];
        return message;
    },
};
/**
 * Client Proxy Service API.
 */
class ClientProxyServiceClient {
    rpc;
    name = 'com.step.clientproxy.proto.ClientProxyService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/client-proxy';
    methods = [{
            name: 'Get',
            requestType: exports.GetUserDataRequest,
            responseType: exports.GetUserDataResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Looks up an existing user with accounts and balances.
     */
    get(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.ClientProxyServiceClient = ClientProxyServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=client-proxy-service.js.map